import React from 'react';
import { configService } from '@/services/config';

export const DevIndicator: React.FC = () => {
  // Only show in development environments
  if (!configService.isDevelopment) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 z-50">
      <div className="flex items-center space-x-2 bg-orange-500 text-white px-3 py-1 rounded-md shadow-lg border border-orange-400">
        <div className="w-2 h-2 bg-orange-300 rounded-full animate-pulse"></div>
        <span className="text-sm font-medium">DEV</span>
      </div>
    </div>
  );
};

export default DevIndicator;
